import { initContract } from "@ts-rest/core";
import { ErrorMessageSchema } from "@common/schemas/error.schema";
import {
    stripeInvoiceJournalEntryModeBodySchema,
    stripeInvoiceJournalEntryModeParamsSchema,
    stripeInvoiceJournalEntryModeResponseSchema,
} from "@common/schemas/domains/stripe/stripe-invoice-journal-entry-mode.schema";
import { stripeCreateConnectionBodySchema } from "@common/schemas/domains/stripe/stripe-connection.schema";
import { integrationConnectionWithAccountsResponseSchema } from "@common/schemas/domains/integrationConnection/integration-connection-response.schema";

const c = initContract();

export const stripeContract = c.router(
    {
        createConnection: {
            method: "POST",
            path: "/",
            body: stripeCreateConnectionBodySchema,
            responses: {
                201: integrationConnectionWithAccountsResponseSchema,
            },
        },
        // Persists the mode only. Invoices already imported keep the value
        // stored on them; the mode applies to invoices imported afterwards.
        // 409: Kick-created Express accounts are pinned to `always`.
        updateInvoiceJournalEntryMode: {
            method: "PATCH",
            path: "/:workspaceId/integration-accounts/:integrationAccountId/invoice-journal-entry-mode",
            pathParams: stripeInvoiceJournalEntryModeParamsSchema,
            body: stripeInvoiceJournalEntryModeBodySchema,
            responses: {
                200: stripeInvoiceJournalEntryModeResponseSchema,
                403: ErrorMessageSchema,
                404: ErrorMessageSchema,
                409: ErrorMessageSchema,
            },
        },
    },
    {
        pathPrefix: "/stripe",
    },
);
